interface TestHookFunc {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (...args: any): any;
}

export const testHook: TestHookFunc = () => {};
